export const CANCELLATION_ORIGINS = Object.freeze({
  admin: "Administrador",
  cliente: "Cliente",
  job_inadimplencia: "Rotina automática de inadimplência",
  asaas: "Asaas (cancelamento automático)",
});
